// @flow
import { cleanupId, generateUniqueId } from 'Utils/unique-id/uniqueId';

import { COLORS } from 'Components/utils/color/colors';

export function getTabsBackgroundClasses(
  hasBackground: boolean = false,
  color: string = COLORS.GRAY_LIGHTER,
) {
  return hasBackground ? `bg-${color} border-b-1 border-t-1 border-gray-light` : '';
}

export function getTabsMainId(items: Array<{ header: { title: string }, title?: string }> = []) {
  const list = items
    .filter(Boolean)
    .map(({ header, title }) => (header && cleanupId(header.title)) || (title && cleanupId(title)))
    .filter(Boolean);

  return generateUniqueId(list, 'tabs-');
}

export function getTabsItemIds({
  id,
  title,
  index,
  mainId,
}: {
  id: string,
  title: string,
  index: number,
  mainId: string,
}) {
  const headerId = id || generateUniqueId([mainId, cleanupId(title), `${index}`], 'tabs-header-');
  const panelId = generateUniqueId(
    [mainId, cleanupId(title), id && `${id}`, `${index}`],
    'tabs-panel-',
  );

  return [headerId, panelId];
}
